import React from 'react';
import { Fab, Box } from 'omaha-design-system';
import { Receipt as ReceiptIcon } from '@phosphor-icons/react';

interface BetSlipFabProps {
  count: number;
  onClick: () => void;
}

export const BetSlipFab: React.FC<BetSlipFabProps> = ({ count, onClick }) => {
  if (count === 0) return null;

  return (
    <Fab
      variant="extended"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 16,
        height: 48,
        borderRadius: '100px',
        backgroundColor: '#42A5F5',
        backgroundImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%)',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
        gap: '4px',
        px: '12px',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#1976d2',
        },
      }}
    >
      <ReceiptIcon size={24} color="rgba(0, 0, 0, 0.87)" />
      <Box
        component="span"
        sx={{
          fontFamily: '"Gilroy", "Instrument Sans", sans-serif',
          fontWeight: 600,
          fontSize: '14px',
          color: 'rgba(0, 0, 0, 0.87)',
        }}
      >
        {count}
      </Box>
    </Fab>
  );
};

export default BetSlipFab;
